import { FC } from 'react'

const AustrianFlag: FC = () => (
  <svg
    width="50"
    height="42"
    viewBox="0 0 50 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="10"
      y="10"
      width="30"
      height="22"
      rx="1"
      fill="white"
    />
    <rect
      x="10"
      y="10"
      width="30"
      height="7.33"
      fill="#ED2939"
    />
    <rect
      x="10"
      y="24.67"
      width="30"
      height="7.33"
      fill="#ED2939"
    />
  </svg>
)

export default AustrianFlag
